import Routes from "routes/Routes";
import CookieAlert from "components/CookieAlert/CookieAlert";

const App: React.FC = () => {
  return (
    <>
      <Routes />
      <CookieAlert />
    </>
  );
};

export default App;
